import { db } from '@/api/firebase'

const feedbackRef = db.collection('feedback')

export {
  feedbackRef
}